/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Watch_NextInputs */

const en_features_watch_next = /** @type {(inputs: Features_Watch_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next: set 3`)
};

const pl_features_watch_next = /** @type {(inputs: Features_Watch_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalej: seria 3`)
};

/**
* | output |
* | --- |
* | "Next: set 3" |
*
* @param {Features_Watch_NextInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_watch_next = /** @type {((inputs?: Features_Watch_NextInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Watch_NextInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_watch_next(inputs)
	return en_features_watch_next(inputs)
});